'use client';

import { getCookie } from 'cookies-next/client';
import { useEffect, useState } from 'react';

const useDetectedCountry = () => {
  const [detectedCountryCode, setDetectedCountryCode] = useState<
    string | null
  >(null);

  useEffect(() => {
    const detected = getCookie('detectedCountryCode');
    if (detected) {
      setDetectedCountryCode(detected);
    }
  }, []);

  return detectedCountryCode;
};

export default useDetectedCountry;

